/**
 * NOTE: If there is any change to this module, also modify jv.video.dummy.js
 * This is required for usecases when video is not enabled.
 */
require('./jv.Videos.Svc.js');
require('./jv.Videos.List.Ctrl.js');

angular.module('jv.Videos.App', [
    'ngRoute',
    'ngSanitize',
    'App.video.service',
    'App.video.details',
    'App.video.evals',
    'App.video.list',
    'App.video.recruiter.router',
    'jv.CandDetails.Video',
    'jv.video.recruiter.list.controller',
    'jv.video.recruiter.details.controller',
    'jv.video.recruiter.evaluations.controller'
]).run(['videoPageService',function(videoPageService){
    if(angular.isDefined(window.JV.CONTACT_IDS)){
        videoPageService.setPageType('CONTACT_DETAIL');
    }else{
        //TODO: VA: NEED TO CLEAN THIS BY FINDING A BETTER METHOD TO SET IT.
        videoPageService.setPageType('CANDIDATE_DETAIL');
    }
}]);
